import Vue from "vue";
import Loading from './loading'
import circle from './circle'
export default {
  install(Vue) {
    Vue.directive('myLoading', Loading)
    Vue.directive('myCircle',circle)
  }
}



// WEBPACK FOOTER //
// ./src/directiveLoading/index.js